module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_1_2.6213772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_1_2.png
// module id = 2l27
// module chunks = 0